import React, { useState, useEffect, useContext } from 'react';
import PageKit from '../PageKit';
import { Context } from "../store/todo_context";
import ZigZagCard from '../component/ZigZagCard';
import ZigZagContainer from '../component/ZigZagContainer';
// import Slidebar from '../component/Slidebar';
import VerticalProjectList from '../component/VerticalProjectList';
import { useTranslation } from 'react-i18next';
import TitleBanner from '../component/TitleBanner';
import ExpertiseTiles from "../component/ExpertiseTiles";
//import MainPageBanner from "../component/MainPageBanner";
import ImageBanner from '../component/ImageBanner';
// import TiltedProjectCard from "../component/TiltedProjectCard";
import TrustedBySection from '../component/TrustedBySection';

function Home() {
    const { t } = useTranslation();
    const contextApi = useContext(Context);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (contextApi.language !== null) {
            setIsLoading(true);
        }
    }, [contextApi.language]);

    return (
        <PageKit>
            <div className="global-background">
                {isLoading ? (
                    <>
                        {/*<MainPageBanner*/}
                        {/*    introSrc={`${process.env.PUBLIC_URL}/video/VideoKoboctIntro.mov`}*/}
                        {/*    fullSrc={`${process.env.PUBLIC_URL}/video/NewVideoKoboctWithoutIntro.mp4`}*/}
                        {/*    centerText={t("MainBanner.Title")}*/}
                        {/*    height="90vh"*/}
                        {/*/>*/}
                        <ImageBanner
                            imageSrc={`${process.env.PUBLIC_URL}/img/Photos/MainBanner.png`}
                            text={t("MainBanner.Title")}
                            height="90vh"
                        />

                        <div id="aboutUs">
                            <ZigZagContainer>
                                <ZigZagCard
                                    imageSrc={`${process.env.PUBLIC_URL}/img/Photos/KOBOCT1.png`}
                                    title={t('ZigZagCards.CompanySpecialtyTitle')}
                                    paragraph={t("ZigZagCards.CompanySpecialty")}
                                />
                                <ZigZagCard
                                    imageSrc={`${process.env.PUBLIC_URL}/img/Photos/vrexample3.jpg`}
                                    title={t('ZigZagCards.CompanyOfferTitle')}
                                    paragraph={t("ZigZagCards.CompanyOffer")}
                                    flip
                                />
                                <ZigZagCard
                                    imageSrc={`${process.env.PUBLIC_URL}/img/Photos/AR.png`}
                                    title={t('ZigZagCards.CompanyGoalTitle')}
                                    paragraph={t("ZigZagCards.CompanyGoal")}
                                />
                            </ZigZagContainer>
                        </div>

                        <div id="services">
                            <ExpertiseTiles
                                tiles={[
                                    {
                                        title: t("ExpertiseTile.VRARTitle"),
                                        description: t('ExpertiseTile.VRARDescription'),
                                        backgroundColor: '#D6AE49',
                                        titleColor: '#ffffff',
                                        descriptionColor: '#ffffff',
                                        borderColor: '#c7d2fe',
                                        image: `${process.env.PUBLIC_URL}/img/Devices/xr.png`
                                    },
                                    {
                                        title: t("ExpertiseTile.ConnectedDevicesTitle"),
                                        description: t('ExpertiseTile.ConnectedDevicesDescription'),
                                        backgroundColor: '#6198C2',
                                        titleColor: '#ffffff',
                                        descriptionColor: '#ffffff',
                                        borderColor: '#a7f3d0',
                                        image: `${process.env.PUBLIC_URL}/img/Devices/haptic-wristband2.png`,
                                        href: '/Connected-Devices',
                                    },
                                    {
                                        title: t('ExpertiseTile.WebGLTitle'),
                                        description: t('ExpertiseTile.WebGLDescription'),
                                        backgroundColor: '#D47D3B',
                                        titleColor: '#ffffff',
                                        descriptionColor: '#ffffff',
                                        borderColor: '#fde68a',
                                        image: `${process.env.PUBLIC_URL}/img/Devices/webgl-screen2.png`,
                                        href: '/web-apps'
                                    }
                                ]}
                            />
                        </div>

                        <div id="ourProjects">
                            {/* Ancien carrousel des projets conservé pour usage futur:
                            <Slidebar title={t("Navbar.OurProjects")}>
                                {[
                                    { url: "XR-Studio", img: "XRStudio.png", title: t('Projects.XR-Studio'), desc: t('Projects.XR-Studio-desc') },
                                    { url: "Online-Library", img: "OnlineLibraryLogo.png", title: t('Projects.OnlineLibrary'), desc: t('Projects.OnlineLibrary-desc') },
                                    { url: "XR-Editor", img: "XREditor.png", title: t('Projects.XR-Editor'), desc: t('Projects.XR-Editor-desc') },
                                    { url: "SAVI", img: "SAVI.png", title: t('Projects.SAVI'), desc: t('Projects.SAVI-desc') },
                                    { url: "VRTE", img: "VRTE.png", title: t('Projects.VRTE'), desc: t('Projects.VRTE-desc') },
                                    { url: "RTE", img: "RTE.png", title: t('Projects.RTE'), desc: t('Projects.RTE-desc') },
                                    { url: "RTE-Router", img: "RTERouteur.png", title: t('Projects.RTE-Router'), desc: t('Projects.RTE-Router-desc') },
                                    { url: "Total", img: "Total.png", title: t('Projects.Total'), desc: t('Projects.Total-desc') },
                                ].map((p, i) => (
                                    <TiltedProjectCard
                                        key={i}
                                        url={p.url}
                                        maxWidth="360px"
                                        minWidth="360px"
                                        imgSrc={`${process.env.PUBLIC_URL}/img/ProjectImages/${p.img}`}
                                        title={p.title}
                                        paragraph={p.desc}
                                    />
                                ))}
                            </Slidebar>
                            */}

                            {/* Nouveau rendu vertical sans lien */}
                            <TitleBanner title={t("Home.SomeProjects")} height='10vh' withShadow={false} />
                            <VerticalProjectList />
                        </div>

                        <TrustedBySection />

                        <TitleBanner
                            style={{ marginTop: '-100px' }}
                            imageSrc={`${process.env.PUBLIC_URL}/img/banners/geometricbannerreversed5.png`}
                            title={t("MainPage.SeparationBanner")}
                            height='50vh'
                            textColor="242F38"
                            button={{ label: t("MainPage.Contact"), href: "/Contact" }}
                            withShadow={false}
                        />
                    </>
                ) : (
                    <div>Loading...</div>
                )}
            </div>
        </PageKit>
    );
}

export default Home;
